module.exports = __webpack_public_path__ + "static/media/BiPartingOutDark.9609a6ff.svg";